/* eslint-disable no-shadow */
import FreeIcon from 'Components/icons/FreeIcon';
import FullIcon from 'Components/icons/FullIcon';
import ProIcon from 'Components/icons/ProIcon';
import ProArrowIcon from 'Components/icons/ProArrowIcon';
import FullArrowIcon from 'Components/icons/FullArrowIcon';
import ProSmallLogo from 'Assets/images/pro_small_logo.svg';
import FullSmallLogo from 'Assets/images/full_small_logo.svg';
import FlexSmallLogo from 'Assets/images/flex.svg';
import FlexLogo from 'Assets/images/flex_logo.svg';
import FullLogo from 'Assets/images/full_logo.svg';
import ProLogo from 'Assets/images/pro_logo.svg';
import BasicLogo from 'Assets/images/logo.svg';
import BasicSmallLogo from 'Assets/images/logo-mobile.svg';

export enum FRONT_PLANS {
  BASIC = 'BASIC',
  FLEX = 'FLEX',
  PRO = 'PRO',
  PRO_PLUS = 'PRO_PLUS',
  FULL = 'FULL',
  FULL_PLUS = 'FULL_PLUS',
  FLEX_LITE = 'FLEX_LITE',
}

export const PLAN_FLEX_LITE = 'Plan Flex Lite';

export const PLAN_SHORT_NAME_DICTIONARY = {
  [FRONT_PLANS.BASIC]: 'Basic',
  [FRONT_PLANS.FLEX]: 'Flex',
  [FRONT_PLANS.FLEX_LITE]: 'Flex',
  [FRONT_PLANS.PRO]: 'Pro',
  [FRONT_PLANS.FULL]: 'Full',
  [FRONT_PLANS.PRO_PLUS]: 'Pro',
  [FRONT_PLANS.FULL_PLUS]: 'Full',
};

const PLAN_NAME_MAPPING = {
  Basic: FRONT_PLANS.BASIC,
  'Plan Flex': FRONT_PLANS.FLEX,
  'Plan Flex Lite': FRONT_PLANS.FLEX,
  'Plan Pro': FRONT_PLANS.PRO,
  'Plan Pro Plus': FRONT_PLANS.PRO_PLUS,
  'Plan Full': FRONT_PLANS.FULL,
  'Plan Full Plus': FRONT_PLANS.FULL_PLUS,
};

export const plansNameMapping = (plan: string): FRONT_PLANS => {
  const value = PLAN_NAME_MAPPING[plan];
  if (!value) return FRONT_PLANS.BASIC;
  return value;
};

export const getPlanToLowerCase = (plan: FRONT_PLANS): string => {
  return PLAN_SHORT_NAME_DICTIONARY[plan]?.toLowerCase();
};
export const getPlanToUpperCase = (plan: FRONT_PLANS): string => {
  return PLAN_SHORT_NAME_DICTIONARY[plan]?.toUpperCase();
};

export const parsePlans = (plan: FRONT_PLANS): FRONT_PLANS => {
  if (!plan) return FRONT_PLANS.BASIC;
  if (plan === FRONT_PLANS.FLEX_LITE) return FRONT_PLANS.FLEX;
  if (plan === FRONT_PLANS.PRO || plan === FRONT_PLANS.PRO_PLUS) return FRONT_PLANS.PRO;
  if (plan === FRONT_PLANS.FULL || plan === FRONT_PLANS.FULL_PLUS) return FRONT_PLANS.FULL;
  return plan;
};

export const plansLogos = {
  [FRONT_PLANS.BASIC]: BasicSmallLogo,
  [FRONT_PLANS.PRO]: ProSmallLogo,
  [FRONT_PLANS.FULL]: FullSmallLogo,
  [FRONT_PLANS.FLEX]: FlexSmallLogo,
};

export const plansFullLogos = {
  [FRONT_PLANS.BASIC]: BasicLogo,
  [FRONT_PLANS.PRO]: ProLogo,
  [FRONT_PLANS.FULL]: FullLogo,
  [FRONT_PLANS.FLEX]: FlexLogo,
};

export const PLANS_MODE = {
  [FRONT_PLANS.PRO]: getPlanToLowerCase(FRONT_PLANS.PRO),
  [FRONT_PLANS.FULL]: getPlanToLowerCase(FRONT_PLANS.FULL),
  [FRONT_PLANS.FLEX]: 'live',
};

export const plansToLongName = (plan: string): string => {
  const value = FRONT_PLANS[plan];
  return `Plan ${PLAN_SHORT_NAME_DICTIONARY[value]}`;
};

export const getLocizeKey = (plan: FRONT_PLANS, action: string): string => {
  return `Plans.${PLAN_SHORT_NAME_DICTIONARY[plan]}.${action}`;
};

export const checkColors = {
  Basic: '#00DC5A',
  Pro: '#2F2E46',
  Full: '#FFC01D',
};

export const IconsPlans = {
  Basic: FreeIcon,
  'Plan Pro': ProIcon,
  'Plan Full': FullIcon,
};

export const ArrowIconsPlans = {
  Pro: ProArrowIcon,
  Full: FullArrowIcon,
};

export const colorsCheck = {
  Basic: '#00DC5A',
  Pro: '#2F2E46',
  Full: '#FFC01D',
};
